import { createFileRoute } from '@tanstack/react-router';
import OnboardingEducation from '@/features/account/onboarding/education';

export const Route = createFileRoute('/onboarding/formacao')({
  component: OnboardingEducation,
});
